//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        list: {
            type: Array,
            default() {
                return [];
            }
        },
        name: {
            type: String,
            default: 'name'
        },
        transition: {
            type: String,
            default: 'fade'
        },
        align: {
            type: String,
            default: 'left' // left right
        },
        color: {
            type: String,
            default: 'inherit'
        }
    },
    data() {
        return {
            show: false
        };
    },
    mounted() {
        // document.addEventListener(
        //     'click',
        //     (eve) => {
        //         this.show = false;
        //     },
        //     {
        //         capture: true
        //     }
        // );
    },
    methods: {
        confirm(data) {
            this.$emit('confirm', data);
            this.show = false;
        }
    }
};
